let threadRunInit: boolean = true

export const setThreadRunInit = (value: boolean) => {
  threadRunInit = value
}

export const getThreadRunInit = () => threadRunInit
